import { render } from "./GroupQuotaRow.vue?vue&type=template&id=2d8e179f&scoped=true"
import script from "./GroupQuotaRow.vue?vue&type=script&lang=js"
export * from "./GroupQuotaRow.vue?vue&type=script&lang=js"

import "./GroupQuotaRow.vue?vue&type=style&index=0&id=2d8e179f&scoped=true&lang=scss"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8e179f"]])

export default __exports__